import { Container, EmptyState, Surface } from '@vst/beam';
import { Alert } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { useNavigate, useScreenResolution } from '@app/hooks';

import styles from './styles.module.scss';

type ConfigurationAddonErrorProps = {
  title: string;
  description: string;
  handlePrimaryAction?: () => void;
};

const ConfigurationAddonError = ({ title, description, handlePrimaryAction }: ConfigurationAddonErrorProps) => {
  const { t } = useTranslation('ShopAddons');
  const { goBack } = useNavigate();
  const { isSmall, isExtraSmall } = useScreenResolution();

  const isMobile = isSmall || isExtraSmall;

  return (
    <Container fluid style={{ marginBlock: 'auto' }}>
      <Surface className={`${styles['container']} ${styles['error']}`} radius="16px">
        <EmptyState
          py={'40px'}
          px={isMobile ? '24px' : '48px'}
          icon={Alert}
          title={title}
          description={description}
          actions={{
            primary: {
              label: t('error.button'),
              onClick: () => {
                if (handlePrimaryAction) {
                  handlePrimaryAction();
                }
                goBack();
              },
              variant: 'primary',
            },
          }}
        />
      </Surface>
    </Container>
  );
};

export default ConfigurationAddonError;
